<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card v-if="!loading">
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{ $tc('page.generic.state', 1) }}</dt>
              <dd class="col-sm-9">
                <custom-switch
                  id="enabled"
                  v-model="procedure.enabled"
                  disabled
                  color="success"
                  variant="pill"
                  label
                />
              </dd>
              <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
              <dd class="col-sm-9">{{procedure.code}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
              <dd class="col-sm-9">{{procedure.label}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.description') }}</dt>
              <dd class="col-sm-9">{{ procedure.description }}</dd>
              <dt class="col-sm-3">{{ $tc('title.procedureTypes', 0) }}</dt>
              <dd class="col-sm-9">{{ procedure.procedureType.label }}</dd>
              <dt class="col-sm-3">{{ $tc('title.sources', 0) }}</dt>
              <dd class="col-sm-9">{{ procedure.source.label }}</dd>
            </dl>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button v-if="isProcedureStandaloneMode" class="btn btn-danger float-right padder" variant="danger" @click="deleteModal = true"
                      type="button">
                {{ $t('actions.delete') }}
              </button>
              <router-link v-if="procedure.id && isProcedureStandaloneMode" class="btn btn-primary float-right" role="button"
                           :to="{name: 'procedureEditRoute', params: {id:procedure.id}}">
                {{ $t('actions.edit') }}
              </router-link>
              <!-- Modal Component -->
              <b-modal title="Eliminazione Prestazione" class="modal-danger" v-model="deleteModal" @ok="deleteProcedure"
                       ok-variant="danger">
                {{ $t('provenance.message.deleteMessage') }}
              </b-modal>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr' //ES6
import PageTitle from '@/components/PageTitle'
import ProcedureService from "@/services/ProcedureService";
import CustomSwitch from "@/components/CustomSwitch";
import Costants from "@/constants/index"

const procedureService = ProcedureService.build();

export default {
  name: 'ProcedureShow',
  props: {
    id: {
      required: true
    }
  },
  components: {
    PageTitle,
    CustomSwitch
  },
  data() {
    return {
      deleteModal: false,
      procedure: {},
      loading: false
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    this.fetchData()
  },
  computed: {
    isProcedureStandaloneMode: function() {
      return JSON.parse(localStorage.getItem('configurations')).procedureMode === Costants.PROCEDURE_STANDALONE_MODE
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;

      try {
        this.procedure = await procedureService.read(this.id)
      } catch (error) {
        console.error(error)
        miniToastr.error(error.message)
      } finally {
        this.loading = false;
      }
    },
    async deleteProcedure() {
      try {
        await procedureService.destroy(this.id);
        this.$router.replace({name: 'procedureRoute'});
        miniToastr.info("Prestazione cancellata con successo!")
      } catch (exception) {
        miniToastr.error(exception.message)
      }
    }
  }
}
</script>
